import { render } from "./course-report.vue?vue&type=template&id=ceb20a4a"
import script from "./course-report.vue?vue&type=script&lang=js"
export * from "./course-report.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__